const STORAGE_KEY = "workith-editor.sidebar.expanded";
const COLLAPSED_KEY = "workith-editor.sidebar.collapsed";

function safeGetItem(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    // localStorage unavailable (private mode / SSR) — treat as empty.
    return null;
  }
}

function safeSetItem(key: string, value: string) {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // localStorage unavailable (private mode / SSR) — ignore.
  }
}

export function readExpandedSidebarNodeIds(): Set<string> {
  const rawValue = safeGetItem(STORAGE_KEY);
  if (!rawValue) {
    return new Set();
  }

  try {
    const parsedValue = JSON.parse(rawValue);
    return Array.isArray(parsedValue)
      ? new Set(parsedValue.filter((item): item is string => typeof item === "string"))
      : new Set();
  } catch {
    return new Set();
  }
}

export function writeExpandedSidebarNodeIds(ids: Set<string>) {
  safeSetItem(STORAGE_KEY, JSON.stringify(Array.from(ids)));
}

export function readSidebarCollapsed(): boolean {
  return safeGetItem(COLLAPSED_KEY) === "true";
}

export function writeSidebarCollapsed(collapsed: boolean) {
  safeSetItem(COLLAPSED_KEY, String(collapsed));
}
